"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var extractor = function (response) { return response.reasons_to_cancel_task; };
var BASE_ROUTE = 'reason_to_cancel_tasks';
var ReasonToCancelTasksEntity = /** @class */ (function (_super) {
    __extends(ReasonToCancelTasksEntity, _super);
    function ReasonToCancelTasksEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: BASE_ROUTE,
            routes: [Entity_1.BaseRoutes.GetAll]
        }) || this;
    }
    ReasonToCancelTasksEntity.prototype.getAll = function (tagId) {
        return this.service.routeGenerator
            .get("/".concat(BASE_ROUTE))
            .withExtractor(extractor)
            .withQueryString({ tag: tagId })
            .setException("Could not fetch delivery for reasons get cancel task tag id #".concat(tagId))
            .invoke();
    };
    return ReasonToCancelTasksEntity;
}(StoreEntity_1.default));
exports.default = ReasonToCancelTasksEntity;
//# sourceMappingURL=ReasonToCancelTasksEntity.js.map